import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const PortalView = () => import('@/views/PortalView.vue');
const PortalIndexView = () => import('@/views/portal/IndexView.vue');
export const NAME_PORTAL = 'Portal';
export const NAME_PORTAL_INDEX = 'PortalIndex';
export const PATH_PORTAL = 'portal';

const children = [
  { path: '', component: PortalIndexView, name: NAME_PORTAL_INDEX, meta: { dataLoaders: ['project_document', 'features', 'portal_base'] } },
];

export const route: DiscoveredRouteModule = {
  id: 'app.portal',
  scope: 'app',
  moduleKey: 'portal',
  name: NAME_PORTAL,
  path: PATH_PORTAL,
  component: PortalView,
  meta: {},
  requiresFeature: 'portal',
  children,
};


